export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/node_modules/d3-chord/src/array.js
// module id = ../../../../d3-chord/src/array.js
// module chunks = vendor